import { Box, Grid, List, Paper, Stack } from '@mui/material';
import useWindowsDimension from 'functions/useWindowsDimension';
import { ITicketViewModel } from 'Interfaces/ITicketConfig';
import { FC } from 'react';

/**
 * Component to display history of ticket products and ticket actions side by side.
 */
export const TicketProductsHistory: FC = () => {
  const { height } = useWindowsDimension();

  // Placeholder ticket data; replace with actual fetch or prop
  const ticketList: Array<{ ticket?: ITicketViewModel[] }> = [];

  return (
    <Box>
      <Stack direction='row'>
        {/* Product list panel */}
        <Paper
          variant='elevation3'
          sx={{
            width: '50%',
            height: Math.ceil(height - 122),
            ml: 2,
            backgroundColor: 'primary.main',
          }}
        >
          <Grid sx={{ p: 2 }}>
            <List
              dense
              sx={{
                p: 1,
                overflow: 'auto',
                height: Math.ceil(height - 222),
                backgroundColor: 'primary.back',
                borderRight: 1,
                borderRightColor: 'primary.text',
                borderBottom: 1,
                borderBottomColor: 'primary.text',
                borderRadius: 3,
              }}
            >
              {ticketList[0]?.ticket?.map((product, index) => (
                <></>
              ))}
            </List>
          </Grid>
        </Paper>

        {/* Ticket history panel */}
        <Paper
          variant='elevation3'
          sx={{
            width: '50%',
            height: Math.ceil(height - 122),
            ml: 2,
            backgroundColor: 'primary.main',
          }}
        >
          <Grid sx={{ p: 2 }}>
            <List
              dense
              sx={{
                p: 1,
                overflow: 'auto',
                height: Math.ceil(height - 222),
                backgroundColor: 'primary.back',
                borderRight: 1,
                borderRightColor: 'primary.text',
                borderBottom: 1,
                borderBottomColor: 'primary.text',
                borderRadius: 3,
              }}
            >
              <></>
            </List>
          </Grid>
        </Paper>
      </Stack>
    </Box>
  );
};
